'use client'

import { useQuery } from '@tanstack/react-query'

import { useAuthInfo } from '@sweetauth/core'

import { fetchRecipient } from '@/context/usaspending'

import type { RecipientProfile } from '@/types/usaspending'

import { usaspendingKeys } from './queryKeys'
import { assertToken } from './utils'

/**
 * Hook to fetch recipient (company) profile details
 *
 * @param id - The recipient ID (UEI or internal ID)
 * @param options.enabled - Whether to enable the query (default: true)
 */
export function useRecipient(id: string, options: { enabled?: boolean } = {}) {
  const { enabled = true } = options
  const { accessToken } = useAuthInfo()

  return useQuery<RecipientProfile>({
    queryKey: usaspendingKeys.recipientDetail(id),
    queryFn: () => fetchRecipient(assertToken(accessToken), id),
    enabled: enabled && !!id && !!accessToken,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
